export const questionsByRole = {
    applicant: [
        {
            question: "Why do you want to work at Pawsible?",
            options: [
              "Because I love animals and want to support them.",
              "Because I believe in providing exceptional service.",
              "Because I care about creating emotionally safe environments.",
              "All of the above"
            ],
            answer: "All of the above"
          },
          {
            question: "According to Pawsible’s care philosophy, what is the correct order of priorities in a pet care setting?",
            options: [
              "Routine > Cleanliness > Speed",
              "Volume > Efficiency > Safety",
              "Safety > Cleanliness > Love (Care)",
              "Speed > Cost > Cleanliness"
            ],
            answer: "Safety > Cleanliness > Love (Care)"
          },
          {
            question: "During your orientation at Pawsible, what mindset should you bring?",
            options: [
              "Stay quiet and only listen",
              "Only focus on policies and rules",
              "Be present, ask questions, and build connection with the team",
              "Try to finish as quickly as possible"
            ],
            answer: "Be present, ask questions, and build connection with the team"
          },          
          {
            question: "Which behavior may signal a dog is uncomfortable?",
            options: [
              "Relaxed tail",
              "Yawning",
              "Running in circles",
              "Rolling on its back"
            ],
            answer: "Yawning"
          },
          {
            question: "Which stage is most critical for dog socialization?",
            options: [
              "Adulthood",
              "Senior years",
              "Puppyhood",
              "6+ years"
            ],
            answer: "Puppyhood"
          },
          {
            question: "What is positive reinforcement?",
            options: [
              "Yelling to stop behavior",
              "Ignoring unwanted behavior",
              "Rewarding desired behavior",
              "Giving treats randomly"
            ],
            answer: "Rewarding desired behavior"
          },
          {
            question: "Which statement best reflects our work culture at Pawsible?",
            options: [
              "Fast and quiet",
              "Top-down authority",
              "Inclusive, ethical, energetic",
              "No-frills efficiency"
            ],
            answer: "Inclusive, ethical, energetic"
          },
          {
            question: "What creates a 'WOW moment' at pick-up?",
            options: [
              "Saying ‘Bye’ quickly",
              "Sharing a happy update or specific moment from their pet’s visit",
              "Avoiding eye contact",
              "Giving a discount"
            ],
            answer: "Sharing a happy update or specific moment from their pet’s visit"
          },
          {
            question: "What is the goal of Pawsible's training pathway?",
            options: [
              "To complete forms",
              "To certify safety and skill through progressive learning",
              "To log hours",
              "To get discounts"
            ],
            answer: "To certify safety and skill through progressive learning"
          },
          {
            question: "How should you respond when a pet parent asks about available services?",
            options: [
              "Say you’re unsure",
              "Hand them a flyer",
              "Explain clearly and ask about their pet’s needs",
              "Tell them to check the website"
            ],
            answer: "Explain clearly and ask about their pet’s needs"
          }          
    ],
    daycare: [
      {
        question: "What’s the first step when a pet arrives in the morning?",
        options: [
          "Let them run to the playgroup",
          "Check service tags and greet warmly",
          "Ask the parent if they fed the dog",
          "Put them in a crate"
        ],
        answer: "Check service tags and greet warmly"
      },
      {
        question: "During a temperament test, what is a red flag?",
        options: [
          "Relaxed tail wag",
          "Polite sniffing",
          "Hard muzzle punch",
          "Taking breaks during play"
        ],
        answer: "Hard muzzle punch"
      },
      {
        question: "What’s the primary purpose of a temperament test?",
        options: [
          "To check obedience training level",
          "To test speed",
          "To assess social safety and group fit",
          "To impress the pet parent"
        ],
        answer: "To assess social safety and group fit"
      },
      {
        question: "What is the goal when grouping dogs for play?",
        options: [
          "Group all small dogs together",
          "Rotate dogs randomly",
          "Sort by play style, energy level, and social cues",
          "Separate based on gender"
        ],
        answer: "Sort by play style, energy level, and social cues"
      },
      {
        question: "When is it necessary to separate a dog from play?",
        options: [
          "If they fall asleep",
          "If they’re being too quiet",
          "If they escalate or repeatedly ignore cues",
          "If they bark once"
        ],
        answer: "If they escalate or repeatedly ignore cues"
      },
      {
        question: "What is positive redirection?",
        options: [
          "Ignoring bad behavior",
          "Rewarding good behavior after guiding away from undesirable action",
          "Physically correcting the dog",
          "Letting them tire out"
        ],
        answer: "Rewarding good behavior after guiding away from undesirable action"
      },
      {
        question: "When play becomes too intense, what should staff do?",
        options: [
          "Watch silently",
          "Use redirection and brief time-out if needed",
          "Let them resolve it naturally",
          "Separate all dogs immediately"
        ],
        answer: "Use redirection and brief time-out if needed"
      },
      {
        question: "Why is enrichment time important?",
        options: [
          "To let staff clean the yard",
          "To give dogs treats",
          "To mentally stimulate and offer structured activities",
          "To encourage napping"
        ],
        answer: "To mentally stimulate and offer structured activities"
      },
      {
        question: "What’s one extra protocol used for puppies?",
        options: [
          "More time-outs",
          "Gentle social exposure and shorter play sessions",
          "Higher calorie meals",
          "Less attention from staff"
        ],
        answer: "Gentle social exposure and shorter play sessions"
      },
      {
        question: "How should we care for senior pets during playtime?",
        options: [
          "Include them in high-energy groups",
          "Avoid any play",
          "Allow rest time and slower social introduction",
          "Ignore them unless they bark"
        ],
        answer: "Allow rest time and slower social introduction"
      },
      {
        question: "What makes a 'WOW' pick-up moment?",
        options: [
          "Giving a discount",
          "Sharing a specific happy moment or update from their dog’s day",
          "Avoiding small talk",
          "A fast exit"
        ],
        answer: "Sharing a specific happy moment or update from their dog’s day"
      },
      {
        question: "What is the goal of daycare photo snapshots?",
        options: [
          "To fill the parent’s inbox",
          "To document issues",
          "To share meaningful, joyful moments",
          "To check which dog is cutest"
        ],
        answer: "To share meaningful, joyful moments"
      },
      {
        question: "Why is sanitation between groups essential?",
        options: [
          "To impress inspectors",
          "To prevent illness and odor buildup",
          "To avoid extra work later",
          "To keep the floors shiny"
        ],
        answer: "To prevent illness and odor buildup"
      },
      {
        question: "What tone should be used when communicating with pet parents?",
        options: [
          "Fast and factual",
          "Formal and distant",
          "Warm, clear, and compassionate",
          "Sales-focused"
        ],
        answer: "Warm, clear, and compassionate"
      },
      {
        question: "What’s the purpose of daily report cards?",
        options: [
          "To rate the dog's appearance",
          "To log feeding times",
          "To communicate the pet’s day clearly and positively to parents",
          "To track staff performance"
        ],
        answer: "To communicate the pet’s day clearly and positively to parents"
      },
      {
        question: "Before feeding a pet, what must be confirmed?",
        options: [
          "If they’re hungry",
          "The parent’s permission and dietary notes",
          "That no other pets are watching",
          "The pet’s age"
        ],
        answer: "The parent’s permission and dietary notes"
      },
      {
        question: "What should you do if two dogs start to escalate during play?",
        options: [
          "Yell loudly to stop them",
          "Step in calmly, redirect, and separate if needed",
          "Spray them with water",
          "Wait to see if they stop on their own"
        ],
        answer: "Step in calmly, redirect, and separate if needed"
      },
      {
        question: "How can you support a shy or anxious dog in playgroup?",
        options: [
          "Ignore them so they can adjust on their own",
          "Place them with only large dogs",
          "Let them watch calmly or pair with a calm role model",
          "Put them in time-out until they’re ready"
        ],
        answer: "Let them watch calmly or pair with a calm role model"
      },
      {
        question: "What is the purpose of tracking play styles?",
        options: [
          "To sort by breed",
          "To rotate toys fairly",
          "To group dogs safely and ensure positive social matches",
          "To set up camera angles"
        ],
        answer: "To group dogs safely and ensure positive social matches"
      },
      {
        question: "What is a key trait of a confident handler?",
        options: [
          "Yells commands loudly",
          "Always stays still",
          "Uses calm body language and stays alert",
          "Avoids giving direction"
        ],
        answer: "Uses calm body language and stays alert"
      },
      {
        question: "How often should playgroup yards be sanitized?",
        options: [
          "Only when there’s an accident",
          "Weekly",
          "After each playgroup rotation or mess",
          "At closing only"
        ],
        answer: "After each playgroup rotation or mess"
      },
      {
        question: "Why is it important to observe each dog’s body language during play?",
        options: [
          "To take cute photos",
          "To spot tension, stress, or conflict early",
          "To check for fleas",
          "To count how many friends they make"
        ],
        answer: "To spot tension, stress, or conflict early"
      },
      {
        question: "What should you do if a pet arrives for daycare but has visible signs of illness?",
        options: [
          "Check them in and monitor",
          "Ask them to leave immediately",
          "Flag for leadership and follow health protocols",
          "Give them a treat and see how they feel later"
        ],
        answer: "Flag for leadership and follow health protocols"
      },
      {
        question: "What’s the staff’s role during transitions (e.g., in/out of yard or quiet time)?",
        options: [
          "Keep the door open for dogs to move freely",
          "Watch from a distance",
          "Actively guide dogs, prevent crowding, and ensure calm entry/exit",
          "Feed dogs treats to move faster"
        ],
        answer: "Actively guide dogs, prevent crowding, and ensure calm entry/exit"
      },
      {
        question: "What makes a daycare experience emotionally safe?",
        options: [
          "Constant activity and excitement",
          "Frequent new dogs and loud environments",
          "Predictable routines, staff awareness, and dog-friendly choices",
          "Letting dogs self-regulate entirely"
        ],
        answer: "Predictable routines, staff awareness, and dog-friendly choices"
      }
    ],
    grooming: [
      {
        question: "Why is a pre-groom check important?",
        options: [
          "To see if the dog is cute",
          "To assess coat condition, skin issues, and behavioral flags",
          "To compare to other pets",
          "To start clipping early"
        ],
        answer: "To assess coat condition, skin issues, and behavioral flags"
      },
      {
        question: "Why do we take pre- and post-groom photos?",
        options: [
          "To show transformation and document conditions",
          "To decorate social media",
          "For staff entertainment",
          "To save storage space"
        ],
        answer: "To show transformation and document conditions"
      },
      {
        question: "If a dog is fearful during the groom, what should you do?",
        options: [
          "Push through quickly",
          "Yell to assert control",
          "Slow down, use soothing voice, and adjust handling technique",
          "Skip the groom"
        ],
        answer: "Slow down, use soothing voice, and adjust handling technique"
      },
      {
        question: "Why are time standards important for grooming?",
        options: [
          "To win competitions",
          "To avoid giving breaks",
          "To ensure pet comfort and efficient scheduling",
          "To increase stress"
        ],
        answer: "To ensure pet comfort and efficient scheduling"
      },
      {
        question: "What’s the proper way to maintain grooming tools?",
        options: [
          "Use until dull",
          "Wipe occasionally",
          "Clean, disinfect, and oil blades regularly",
          "Keep in a drawer"
        ],
        answer: "Clean, disinfect, and oil blades regularly"
      },
      {
        question: "What should you share with the client at pick-up?",
        options: [
          "Just say 'all done'",
          "Detailed notes on behavior, haircut, and any observations",
          "Only the cost",
          "Nothing unless they ask"
        ],
        answer: "Detailed notes on behavior, haircut, and any observations"
      },
      {
        question: "If you notice a new lump or rash, what should you do?",
        options: [
          "Ignore it",
          "Make a joke",
          "Note it and inform the client at pickup with compassion",
          "Tell another client instead"
        ],
        answer: "Note it and inform the client at pickup with compassion"
      },
      {
        question: "Which of these signals may indicate stress in a grooming dog?",
        options: [
          "Soft blinking",
          "Happy tail wags",
          "Panting, trembling, lip licking",
          "Rolling over for belly rubs"
        ],
        answer: "Panting, trembling, lip licking"
      },
      {
        question: "If you find fleas during check-in, what should you do?",
        options: [
          "Ignore them",
          "Notify the client and follow flea protocol before proceeding",
          "Continue bathing",
          "Shave immediately"
        ],
        answer: "Notify the client and follow flea protocol before proceeding"
      },
      {
        question: "Which areas are considered high-risk zones for skin injury and should be groomed with extra care, especially in anxious or sensitive dogs?",
        options: [
          "Topline and tail",
          "Back paws and ears",
          "Sanitary area, face, and folding skin between legs or underarms",
          "Chest and belly"
        ],
        answer: "Sanitary area, face, and folding skin between legs or underarms"
      },      
      {
        question: "Why is it important to check ear condition before bathing?",
        options: [
          "To match ear bows to fur color",
          "To avoid trapping moisture if infected",
          "To see if they need a trim",
          "To determine breed"
        ],
        answer: "To avoid trapping moisture if infected"
      },
      {
        question: "If severe matting is found behind the ears and underarms, what should you do?",
        options: [
          "Ignore it unless the parent asks",
          "Use excessive brushing",
          "Notify the parent and follow dematting or shave policy",
          "Clip over the mats directly"
        ],
        answer: "Notify the parent and follow dematting or shave policy"
      },
      {
        question: "What type of shampoo should you use on a dog with itchy, flaky skin?",
        options: [
          "Brightening shampoo",
          "De-shedding shampoo",
          "Oatmeal or hypoallergenic shampoo",
          "Puppy shampoo"
        ],
        answer: "Oatmeal or hypoallergenic shampoo"
      },
      {
        question: "Why is brushing before bathing important on certain coats?",
        options: [
          "To make them look fluffier",
          "To remove dirt only",
          "To prevent mats from tightening and causing pain after drying",
          "To save drying time"
        ],
        answer: "To prevent mats from tightening and causing pain after drying"
      },
      {
        question: "How can you help build trust with a new grooming guest?",
        options: [
          "Speak loudly to show confidence",
          "Rush through the groom to finish faster",
          "Move slowly, speak calmly, and reward small wins",
          "Avoid eye contact"
        ],
        answer: "Move slowly, speak calmly, and reward small wins"
      },
      {
        question: "If a dog begins showing signs of aggression during the groom (growling, lunging, snapping), what is the appropriate course of action?",
        options: [
          "Use force to assert control and finish the groom quickly",
          "Continue grooming as normal until the pet calms down",
          "Stop immediately, assess the behavior, and proceed only if safe using proper restraint tools like a muzzle or second handler",
          "Refuse to touch the dog and call the client right away"
        ],
        answer: "Stop immediately, assess the behavior, and proceed only if safe using proper restraint tools like a muzzle or second handler"
      },      
      {
        question: "When is it appropriate to decline or pause a groom?",
        options: [
          "When you're tired",
          "If the pet is in visible distress or it’s unsafe to continue",
          "If the pet is small",
          "If the owner didn’t tip"
        ],
        answer: "If the pet is in visible distress or it’s unsafe to continue"
      },
      {
        question: "Why should you keep your grooming station tidy between grooms?",
        options: [
          "To impress coworkers",
          "To find your tools faster",
          "To maintain safety, efficiency, and hygiene",
          "To avoid losing shampoo"
        ],
        answer: "To maintain safety, efficiency, and hygiene"
      },
      {
        question: "What is a 'teddy bear style' typically referring to?",
        options: [
          "A specific tail trim",
          "Rounded and adorable face with proportional body trim",
          "Shaving the belly",
          "Removing all fluff"
        ],
        answer: "Rounded and adorable face with proportional body trim"
      },
      {
        question: "When using a high-velocity dryer, what is an important safety precaution?",
        options: [
          "Point it directly into ears",
          "Always use full power immediately",
          "Avoid sensitive areas and monitor pet's body language",
          "Let the dog walk around freely"
        ],
        answer: "Avoid sensitive areas and monitor pet's body language"
      },
      {
        question: "If a dog defecates during grooming, what should you do?",
        options: [
          "Ignore it and keep grooming",
          "Scold the dog",
          "Pause, clean the pet and area calmly, then resume when safe",
          "Call the owner immediately"
        ],
        answer: "Pause, clean the pet and area calmly, then resume when safe"
      },
      {
        question: "Why should client notes be updated after every groom?",
        options: [
          "To compare against other groomers",
          "To track client spending habits",
          "To ensure consistency, flag issues, and document client preferences",
          "To rate how difficult the pet was"
        ],
        answer: "To ensure consistency, flag issues, and document client preferences"
      },
      {
        question: "If a client requests a style that isn’t suitable for the dog’s coat type, what should you do?",
        options: [
          "Follow the instructions exactly anyway",
          "Suggest an alternative that suits the coat and explain why",
          "Tell them you won’t groom the dog",
          "Ignore the request"
        ],
        answer: "Suggest an alternative that suits the coat and explain why"
      },
      {
        question: "What does it mean if an equipment becomes very hot mid-groom?",
        options: [
          "It’s working well",
          "The motor is cooling down",
          "It poses a burn risk and should be cooled or swapped",
          "It should be pushed harder through thick fur"
        ],
        answer: "It poses a burn risk and should be cooled or swapped"
      },
      {
        question: "When restraining a wiggly dog for grooming, what’s the safest method?",
        options: [
          "Hold them by the muzzle firmly",
          "Use gentle, minimal restraint and wait for calm moments",
          "Quick snip while they move",
          "Ask another groomer to pin them"
        ],
        answer: "Use gentle, minimal restraint and wait for calm moments"
      }
    ],
    receptionist: [
      {
        question: "What’s the most important way to greet a client walking in the door?",
        options: [
          "Smile and acknowledge them warmly, even if you’re on the phone",
          "Wave quickly and keep typing",
          "Wait for them to speak first",
          "Point them toward the check-in sheet"
        ],
        answer: "Smile and acknowledge them warmly, even if you’re on the phone"
      },
      {
        question: "How do you ensure the first impression leaves a lasting positive impact?",
        options: [
          "Maintain eye contact, smile, and actively listen to their needs",
          "Rush through the check-in process to speed things up",
          "Focus only on the pet’s needs, not the client’s",
          "Offer immediate discounts"
        ],
        answer: "Maintain eye contact, smile, and actively listen to their needs"
      },
      {
        question: "What is the most effective way to guide a new client through the Paw Parent app?",
        options: [
          "Give them a brief overview and let them figure it out themselves",
          "Ask them to visit the website for FAQs",
          "Take them through key features like booking services, checking schedules, and viewing payment options",
          "Only help them if they ask for assistance"
        ],
        answer: "Take them through key features like booking services, checking schedules, and viewing payment options"
      },
      {
        question: "How should you respond if a client asks a question about the Paw Parent app that you don’t know?",
        options: [
          "Direct them to the FAQs and leave them to figure it out",
          "Tell them you don’t know and ask them to contact support",
          "Offer to assist them by navigating the app together or suggest they speak with someone more experienced",
          "Ignore the question and move on"
        ],
        answer: "Offer to assist them by navigating the app together or suggest they speak with someone more experienced"
      },
      {
        question: "What is the first step in the check-in process?",
        options: [
          "Confirm the pet’s arrival and verify booking details",
          "Ask the pet parent if they’ve made any last-minute changes",
          "Take the payment right away",
          "Get the pet ready for service immediately"
        ],
        answer: "Confirm the pet’s arrival and verify booking details"
      },
      {
        question: "How should the check-out process be handled to ensure a smooth experience?",
        options: [
          "Rush through payment and hand over the pet without explanation",
          "Take time to review the service and ask for feedback",
          "Simply tell the client the amount they owe and let them leave",
          "Only check out the pet when the client is ready"
        ],
        answer: "Take time to review the service and ask for feedback"
      },
      {
        question: "How should you answer the phone at Pawsible?",
        options: [
          "Pawsible, this is [Your Name], how can I help you today?",
          "Hello?",
          "Pawsible front desk, what do you need?",
          "We’re busy, please hold"
        ],
        answer: "Pawsible, this is [Your Name], how can I help you today?"
      },
      {
        question: "If a client is late to check in for daycare, what should you do?",
        options: [
          "Turn them away",
          "Greet them warmly and check service tags for any changes",
          "Charge them extra",
          "Rush them through the system"
        ],
        answer: "Greet them warmly and check service tags for any changes"
      },
      {
        question: "What should you do if you don’t know the answer to a client’s question?",
        options: [
          "Make something up so they’re not left waiting",
          "Tell them to check the website",
          "Say you're unsure and immediately offer to ask a team lead or manager",
          "Ignore the question"
        ],
        answer: "Say you're unsure and immediately offer to ask a team lead or manager"
      },
      {
        question: "If a pet parent seems upset or impatient, what should you do first?",
        options: [
          "Ignore them until they calm down",
          "Match their energy to show you care",
          "Stay calm, listen without interrupting, and validate their concern",
          "Offer a discount immediately"
        ],
        answer: "Stay calm, listen without interrupting, and validate their concern"
      },
      {
        question: "What should you do if you don’t know the answer to a client’s question?",
        options: [
          "Make something up so they’re not left waiting",
          "Tell them to check the website",
          "Say you're unsure and immediately offer to ask a team lead or manager",
          "Ignore the question"
        ],
        answer: "Say you're unsure and immediately offer to ask a team lead or manager"
      },
      {
        question: "What should you do if a client requests a service change or addition during an existing booking?",
        options: [
          "Make the change in the system, inform the client, and confirm the new details",
          "Ask them to call back later",
          "Say no and suggest they book separately",
          "Ignore their request"
        ],
        answer: "Make the change in the system, inform the client, and confirm the new details"
      },
      {
        question: "Why are client special notes important in the app dashboard?",
        options: [
          "They help staff track behavior, allergies, or service preferences",
          "They look nice",
          "They increase marketing",
          "They’re only for emergencies"
        ],
        answer: "They help staff track behavior, allergies, or service preferences"
      },
      {
        question: "If a pet has a 'must hand off to trainer' note, what does this mean for reception?",
        options: [
          "Trainer must come get the dog from the front",
          "Client can drop off in the back",
          "Reception should leash the dog and take them to training",
          "Ignore the tag"
        ],
        answer: "Trainer must come get the dog from the front"
      },
      {
        question: "What is a 'WOW moment' for the front desk?",
        options: [
          "Handing out coupons",
          "Giving detailed updates, using the pet’s name, and sending the client off with warmth",
          "Ringing the bell loudly",
          "Offering treats to every pet"
        ],
        answer: "Giving detailed updates, using the pet’s name, and sending the client off with warmth"
      },
      {
        question: "If a client shows up 15 minutes early for pick-up and the pet isn’t ready, how should you respond?",
        options: [
          "Tell them to come back later",
          "Apologize and check with the team while keeping the client informed",
          "Blame the groomer",
          "Act annoyed"
        ],
        answer: "Apologize and check with the team while keeping the client informed"
      },
      {
        question: "What’s the proper way to handle a payment error during checkout?",
        options: [
          "Apologize, recheck the payment system, and notify the client of any necessary steps",
          "Ignore it and let the client handle it later",
          "Tell the client to come back another day",
          "Ask the client to pay in cash next time"
        ],
        answer: "Apologize, recheck the payment system, and notify the client of any necessary steps"
      },
      {
        question: "If a client requests a refund for a service, what should you do first?",
        options: [
          "Refuse the refund immediately",
          "Check the service terms and validate the client’s reason for the refund",
          "Offer a discount for the next service instead of a refund",
          "Ask the client to leave the premises"
        ],
        answer: "Check the service terms and validate the client’s reason for the refund"
      },
      {
        question: "If a client cancels last minute, what is the correct protocol?",
        options: [
          "Remove the booking without saying anything",
          "Politely remind them of the cancellation policy and log it in the system",
          "Ignore the cancellation",
          "Tell them they’re not allowed to rebook"
        ],
        answer: "Politely remind them of the cancellation policy and log it in the system"
      },            
      {
        question: "What’s the best way to confirm a multi-service booking (e.g. daycare + training)?",
        options: [
          "Book it all under one service",
          "Write it on a sticky note for the trainer",
          "Ensure both services are booked in the system and all departments are notified",
          "Let the trainer figure it out"
        ],
        answer: "Ensure both services are booked in the system and all departments are notified"
      },
      {
        question: "If a client says they left their leash behind, what should you do?",
        options: [
          "Tell them it’s probably lost",
          "Check the Lost & Found, log it, and follow up",
          "Say it’s not your responsibility",
          "Offer them someone else’s leash"
        ],
        answer: "Check the Lost & Found, log it, and follow up"
      },
      {
        question: "How should you communicate with a team member about an incident a client mentioned at check-out?",
        options: [
          "Wait until your shift ends",
          "Log it in the dashboard and notify a manager or the appropriate team member",
          "Text them personally",
          "Forget about it unless they ask"
        ],
        answer: "Log it in the dashboard and notify a manager or the appropriate team member"
      },
      {
        question: "A new client walks in without an appointment. What’s the best response?",
        options: [
          "Turn them away immediately",
          "Greet them warmly, explain our process, and offer to schedule a trial or tour",
          "Tell them we’re too busy",
          "Ask them to download the app and leave"
        ],
        answer: "Greet them warmly, explain our process, and offer to schedule a trial or tour"
      },
      {
        question: "If two phone lines are ringing at once, what’s the most professional action?",
        options: [
          "Ignore one and answer the other",
          "Let both go to voicemail",
          "Answer the first call quickly, place them on a brief hold, and answer the second",
          "Answer both at the same time"
        ],
        answer: "Answer the first call quickly, place them on a brief hold, and answer the second"
      },
      {
        question: "How can you help upsell a service respectfully during check-in?",
        options: [
          "Suggest additional services based on the pet’s needs and recent history",
          "Ask them if they want to spend more money",
          "Offer services without knowing their pet",
          "Say nothing and hope they ask"
        ],
        answer: "Suggest additional services based on the pet’s needs and recent history"
      },  
    ],
    trainer: [
      {
        question: "What is the core of Pawsible’s training philosophy?",
        options: [
          "Quick correction and control",
          "Firm dominance over the dog",
          "Positive reinforcement, consistency, and emotional safety",
          "Letting dogs figure things out on their own"
        ],
        answer: "Positive reinforcement, consistency, and emotional safety"
      },
      {
        question: "Which of the following tools are *approved* at Pawsible for training sessions?",
        options: [
          "Flat collars, harnesses, treats, clickers, slip leads if needed",
          "Shock collars and spray bottles",
          "Prong collars and leash pops",
          "No tools—only verbal commands"
        ],
        answer: "Flat collars, harnesses, treats, clickers, slip leads if needed"
      },
      {
        question: "Why is your body language important during training sessions?",
        options: [
          "Dogs respond to subtle cues like posture, tone, and facial expression",
          "It makes you look more professional to clients",
          "It keeps the dog guessing",
          "It doesn’t matter as long as you say the cue clearly"
        ],
        answer: "Dogs respond to subtle cues like posture, tone, and facial expression"
      },
      {
        question: "What kind of energy should a trainer bring to every session?",
        options: [
          "Strict and serious",
          "Energetic but chaotic",
          "Calm, confident, and clear",
          "High-energy and dominant"
        ],
        answer: "Calm, confident, and clear"
      },
      {
        question: "What is one key goal during the first client intake or orientation?",
        options: [
          "To immediately start working on advanced cues",
          "To evaluate the dog’s behavior and build trust with the parent",
          "To correct any bad behavior right away",
          "To offer a discount on sessions"
        ],
        answer: "To evaluate the dog’s behavior and build trust with the parent"
      },
      {
        question: "If a pet parent shares training goals that seem unrealistic, what should you do?",
        options: [
          "Promise results to make them happy",
          "Correct them gently and let them know it may not be possible",
          "Validate their hope, then clearly explain the realistic plan and process",
          "Tell them to try a different trainer"
        ],
        answer: "Validate their hope, then clearly explain the realistic plan and process"
      },
      {
        question: "Before starting a training session, what is a non-negotiable step?",
        options: [
          "Making sure the playlist is on",
          "Checking the dog’s nails",
          "Ensuring the space is prepped, safe, and distraction-aware",
          "Letting the dog run free"
        ],
        answer: "Ensuring the space is prepped, safe, and distraction-aware"
      },
      {
        question: "During a private session, how should a trainer explain the 'why' behind each exercise?",
        options: [
          "Keep it vague—clients only care about results",
          "Offer brief but clear reasoning tied to behavior goals",
          "Avoid overexplaining to avoid slowing things down",
          "Use technical jargon to sound more advanced"
        ],
        answer: "Offer brief but clear reasoning tied to behavior goals"
      },
      {
        question: "If a dog is visibly stressed during a private session, what should the trainer do?",
        options: [
          "Push through to stay on schedule",
          "Correct the dog and keep going",
          "Pause, readjust the session, and explain the change to the client",
          "Ignore the dog’s behavior and focus on the handler"
        ],
        answer: "Pause, readjust the session, and explain the change to the client"
      },
      {
        question: "What’s a trainer’s role during a group class with mixed energy levels?",
        options: [
          "Let all dogs work at the same pace",
          "Match the pace to the fastest dog",
          "Adjust activities and provide coaching per dog’s comfort level",
          "Focus only on the loudest dogs"
        ],
        answer: "Adjust activities and provide coaching per dog’s comfort level"
      },
      {
        question: "What should be done if two dogs in group class begin showing tension?",
        options: [
          "Let them work it out unless it escalates",
          "End class early",
          "Interrupt with redirection and adjust spacing or activities as needed",
          "Use a squirt bottle to correct them"
        ],
        answer: "Interrupt with redirection and adjust spacing or activities as needed"
      },
      {
        question: "What is the most important focus during puppy classes?",
        options: [
          "Perfecting leash skills",
          "Teaching tricks",
          "Building positive associations and early socialization",
          "Correcting bad behavior"
        ],
        answer: "Building positive associations and early socialization"
      },
      {
        question: "If a dog is shy or overwhelmed in class, what should you do?",
        options: [
          "Ignore it and let them catch up",
          "Encourage gentle exposure and allow space to observe without pressure",
          "Push them into play for faster adjustment",
          "Keep them isolated"
        ],
        answer: "Encourage gentle exposure and allow space to observe without pressure"
      },
      {
        question: "What should be included in homework notes after a session?",
        options: [
          "Just say the dog did well",
          "Step-by-step cues, progress notes, and how to practice at home",
          "A general summary of the day",
          "Only concerns, not wins"
        ],
        answer: "Step-by-step cues, progress notes, and how to practice at home"
      },
      {
        question: "Why is it important to track training progress after each session?",
        options: [
          "So the trainer doesn’t forget the dog’s name",
          "To justify charging more",
          "To build a transparent record and ensure steady, personalized improvement",
          "To fill out forms"
        ],
        answer: "To build a transparent record and ensure steady, personalized improvement"
      },
      {
        question: "Why is it important to reduce environmental distractions during training?",
        options: [
          "So the dog doesn’t get bored",
          "To help the trainer stay focused",
          "To allow dogs to build clarity and success with each cue",
          "To keep the space looking clean"
        ],
        answer: "To allow dogs to build clarity and success with each cue"
      },
      {
        question: "What’s a trainer’s role during downtime in a group class?",
        options: [
          "Let clients chat freely",
          "Scroll through your phone",
          "Offer feedback, answer questions, and support pairs individually",
          "Take a break"
        ],
        answer: "Offer feedback, answer questions, and support pairs individually"
      },
      {
        question: "When should client handouts or guides be provided?",
        options: [
          "Only when requested",
          "After the final session",
          "When discussing new concepts or sending home training homework",
          "Never—it’s all verbal"
        ],
        answer: "When discussing new concepts or sending home training homework"
      },
      {
        question: "What is the trainer’s responsibility after a new client finishes their first session?",
        options: [
          "Forget about it unless they rebook",
          "Send a follow-up with progress notes and next steps",
          "Only call if there was a problem",
          "Ask someone else to contact them"
        ],
        answer: "Send a follow-up with progress notes and next steps"
      },
      {
        question: "What’s the best way to explain a training setback to a pet parent?",
        options: [
          "Avoid bringing it up",
          "Say the dog is too stubborn",
          "Blame the client for inconsistent practice",
          "Frame it as part of the learning curve and adjust the plan with encouragement"
        ],
        answer: "Frame it as part of the learning curve and adjust the plan with encouragement"
      },
      {
        question: "When should dogs in a group class be allowed to directly interact?",
        options: [
          "During every class",
          "Whenever they want to",
          "Only when it’s planned, safe, and structured",
          "Never—they should remain isolated"
        ],
        answer: "Only when it’s planned, safe, and structured"
      },
      {
        question: "What makes a strong follow-up email after a training session?",
        options: [
          "A recap of exercises, what to practice, and encouraging tone",
          "Only the client’s receipt",
          "A list of things the dog did wrong",
          "No email—only phone calls matter"
        ],
        answer: "A recap of exercises, what to practice, and encouraging tone"
      },
      {
        question: "Why do we avoid punishment-based tools like e-collars or alpha rolls at Pawsible?",
        options: [
          "They don’t work",
          "They create fear, damage trust, and conflict with our positive reinforcement values",
          "They’re too expensive",
          "Clients dislike the look"
        ],
        answer: "They create fear, damage trust, and conflict with our positive reinforcement values"
      },
      {
        question: "Which behavior should immediately trigger a pause in training and escalation to the manager or behavior specialist?",
        options: [
          "Mild barking at strangers",
          "Ignoring a recall cue",
          "Prolonged fixated stare, growling, or snapping",
          "Refusing to sit on cue"
        ],
        answer: "Prolonged fixated stare, growling, or snapping"
      },
      {
        question: "If a dog becomes increasingly reactive during a session despite redirection efforts, what should the trainer do?",
        options: [
          "Continue the session to maintain authority",
          "Raise your voice to regain control",
          "Pause the session, create space, and consult with the behavior lead or manager",
          "Ignore the reactivity if there’s no physical aggression"
        ],
        answer: "Pause the session, create space, and consult with the manager"
      }    
    ],
    shuttle: [
      {
        question: "Why is maintaining shuttle cleanliness important at Pawsible?",
        options: [
          "So it smells nice",
          "To ensure a sanitary, safe, and professional environment for pets and clients",
          "To impress inspectors only",
          "Because the manager asked"
        ],
        answer: "To ensure a sanitary, safe, and professional environment for pets and clients"
      },
      {
        question: "What must a driver check before leaving for the first pickup?",
        options: [
          "That the A/C works and the windows are clean",
          "That you have music and your personal bag",
          "Vehicle safety checklist: fuel, crate locks, emergency supplies, and route overview",
          "Only the destination list"
        ],
        answer: "Vehicle safety checklist: fuel, latch locks, emergency supplies, and route overview"
      },
      {
        question: "What’s the ideal communication if you’re running 10+ minutes behind schedule?",
        options: [
          "Ignore it unless a client asks",
          "Blame traffic when you arrive",
          "Contact the client and front desk to update on new ETA",
          "Text another driver"
        ],
        answer: "Contact the client and front desk to update on new ETA"
      },
      {
        question: "If a pet parent is not home at the scheduled time, what’s your first step?",
        options: [
          "Wait for up to 30 minutes",
          "Mark the pet as a no-show and leave immediately",
          "Attempt a call, wait 3–5 minutes, and conduct return if needed",
          "Knock once and leave"
        ],
        answer: "Attempt a call, wait 3–5 minutes, and conduct return if needed"
      },
      {
        question: "What is required before starting the engine with dogs on board?",
        options: [
          "Music turned down",
          "All equipments securely latched, dogs calm, and doors locked",
          "All dogs leashed and roaming",
          "A/c on full blast"
        ],
        answer: "All equipments securely latched, dogs calm, and doors locked"
      },
      {
        question: "How should route planning be handled before morning pickups?",
        options: [
          "Follow yesterday’s route exactly",
          "Take the fastest highway route regardless of stops",
          "Use the dashboard schedule and GPS to confirm order, efficiency, and timing",
          "Ask another driver for ideas"
        ],
        answer: "Use the dashboard schedule and GPS to confirm order, efficiency, and timing"
      },
      {
        question: "What is the best way to greet a pet parent at the door?",
        options: [
          "Wave from the car",
          "Keep sunglasses on and speak quickly",
          "Smile, use their pet’s name, and confirm handoff clearly",
          "Avoid talking unless they ask"
        ],
        answer: "Smile, use their pet’s name, and confirm handoff clearly"
      },
      {
        question: "If two dogs start barking or growling in the shuttle, what should you do?",
        options: [
          "Keep driving and ignore it",
          "Yell to quiet them",
          "Redirect with 'Hey!', safely pull over, and assess if separation is needed.",
          "Call every client involved"
        ],
        answer: "Redirect with 'Hey!', safely pull over, and assess if separation is needed."
      },
      {
        question: "What must you do if a dog vomits or has an accident during transit?",
        options: [
          "Ignore it until the next stop",
          "Note it and tell the parent later if you remember",
          "Stop when safe, clean it promptly, and notify the front desk or parent",
          "Ask the client to clean it at drop-off"
        ],
        answer: "Stop when safe, clean it promptly, and notify the front desk or parent"
      },
      {
        question: "How should dogs be loaded into the vehicle?",
        options: [
          "Quickly, in any order",
          "By energy level and temperament, using calm, confident leash handling",
          "Let them jump in freely",
          "Small dogs last"
        ],
        answer: "By energy level and temperament, using calm, confident leash handling"
      },
      {
        question: "How should you stay on track when a pet handoff takes longer than expected?",
        options: [
          "Rush the rest of your route",
          "Skip breaks",
          "Update the front desk, adjust ETA if needed, and prioritize safety over speed",
          "Ignore it and keep going"
        ],
        answer: "Update the front desk, adjust ETA if needed, and prioritize safety over speed"
      },
      {
        question: "What should be in the shuttle emergency kit?",
        options: [
          "First aid supplies, gloves, paper towels, leash, and water.",
          "Snacks, charger, and pet toys",
          "Spray bottle and pee pads",
          "Business cards"
        ],
        answer: "First aid supplies, gloves, paper towels, leash, and water."
      },
      {
        question: "What should you do if you notice a mechanical issue during your route?",
        options: [
          "Drive carefully and report it later",
          "Wait for a client to say something",
          "Contact a manager immediately, and pull over if it’s a safety risk",
          "Ignore it if the shuttle still runs"
        ],
        answer: "Contact a manager immediately, and pull over if it’s a safety risk"
      },
      {
        question: "How often should you visually check the pets in your vehicle?",
        options: [
          "Only at drop-off",
          "Whenever the vehicle stops",
          "At every pickup and when safely parked, before and after transport",
          "Every 15 minutes while driving"
        ],
        answer: "At every pickup and when safely parked, before and after transport"
      },
      {
        question: "Which dogs should be loaded first into the shuttle?",
        options: [
          "The loudest ones",
          "The smallest ones",
          "The calmest or most stable dogs",
          "Any available dog"
        ],
        answer: "The calmest or most stable dogs"
      },
      {
        question: "If a client seems in a rush during handoff, what should you still confirm?",
        options: [
          "Nothing—just grab the dog",
          "Ask for a tip",
          "The pet’s name, condition, and pickup time",
          "Whether they have any snacks for the pet"
        ],
        answer: "The pet’s name, condition, and pickup time"
      },
      {
        question: "If a client mentions their dog gets motion sickness, what should you do?",
        options: [
          "Ignore it unless they vomit",
          "Place them near a window",
          "Note it on the dashboard and adjust crate placement for minimal movement",
          "Give the dog a treat before loading"
        ],
        answer: "Reassure the owner and adjust seat placement for minimal movement"
      },
      {
        question: "Before clocking out, what’s one final driver responsibility?",
        options: [
          "Clean out seats, check fuel, and submit the shuttle report",
          "Leave keys anywhere",
          "Just clock out on the app",
          "Check social media"
        ],
        answer: "Clean out seats, check fuel, and submit the shuttle report"
      },
      {
        question: "What belongs in your end-of-day shuttle report?",
        options: [
          "Only delays or problems",
          "What snacks you ate",
          "Notes on timing, behavior, seat conditions, and any communication with clients",
          "Client tips received"
        ],
        answer: "Notes on timing, behavior, seat conditions, and any communication with clients"
      },
      {
        question: "What’s the most important mindset for a Pawsible shuttle driver to maintain?",
        options: [
          "Strict and fast-paced",
          "Silent and hands-off",
          "Calm, communicative, and safety-focused at every step",
          "Energetic and reactive"
        ],
        answer: "Calm, communicative, and safety-focused at every step"
      }
    ],
    manager: [
      {
        question: "What is the most important responsibility of a manager at Pawsible?",
        options: [
          "To complete all services personally",
          "To ensure safety, support staff, and uphold operational flow across department",
          "To monitor only grooming timelines",
          "To avoid getting involved unless there's an issue"
        ],
        answer: "To ensure safety, support staff, and uphold operational flow across departments"
      },
      {
        question: "If two departments are short-staffed at once, what should a manager prioritize?",
        options: [
          "Whichever department brings in more revenue",
          "The one with the most vocal team members",
          "Client-facing coverage and safety-sensitive roles first, then delegate support accordingly",
          "Whichever one is closer to the office"
        ],
        answer: "Client-facing coverage and safety-sensitive roles first, then delegate support accordingly"
      },
      {
        question: "When should a manager escalate an incident to senior?",
        options: [
          "If it involves physical injury, legal concern, or client complaint with risk",
          "Any time someone is unhappy",
          "Only when staff ask you to",
          "At the end of your shift"
        ],
        answer: "If it involves physical injury, legal concern, or client complaint with risk"
      },
      {
        question: "A team member reports feeling overwhelmed with back-to-back tasks. What is the best immediate action?",
        options: [
          "Tell them to push through and finish",
          "Reassign or pause non-urgent tasks and check on their workload distribution",
          "Ask them to work faster",
          "Ignore the concern"
        ],
        answer: "Reassign or pause non-urgent tasks and check on their workload distribution"
      },
      {
        question: "If a client expresses frustration at the front desk, what’s the manager’s role?",
        options: [
          "Let front desk handle it unless it gets worse",
          "Step in with calm authority, listen empathetically, and seek resolution or follow-up",
          "Avoid contact until they leave",
          "Offer a refund immediately"
        ],
        answer: "Step in with calm authority, listen empathetically, and seek resolution or follow-up"
      },
      {
        question: "How should a manager address a repeated staff mistake (e.g., wrong booking or grooming miscommunication)?",
        options: [
          "Write them up right away",
          "Call them out in front of the team",
          "Speak 1-on-1, review the SOP, and provide coaching or a systems reminder",
          "Ignore it unless it happens again"
        ],
        answer: "Speak 1-on-1, review the SOP, and provide coaching or a systems reminder"
      },
      {
        question: "During an emergency (e.g., dog fight or facility hazard), what is the first response?",
        options: [
          "Log the incident and review video later",
          "Ensure safety of pets and people first, then follow the emergency SOP and document",
          "Call the owner immediately",
          "Send everyone home"
        ],
        answer: "Ensure safety of pets and people first, then follow the emergency SOP and document"
      },
      {
        question: "What’s the purpose of the manager dashboard view in Pawsible’s system?",
        options: [
          "To track staff birthdays",
          "To view all department activity, monitor flags, and manage incident follow-ups",
          "To check social media stats",
          "To input client reviews"
        ],
        answer: "To view all department activity, monitor flags, and manage incident follow-ups"
      },
      {
        question: "If a new team member is underperforming during their first week, what’s the best next step?",
        options: [
          "Let them go immediately",
          "Assign them a mentor and review progress with training leads",
          "Put them on probation right away",
          "Reassign them to front desk permanently"
        ],
        answer: "Assign them a mentor and review progress with training leads"
      },
      {
        question: "What is the best way for a manager to support a high-performing team long-term?",
        options: [
          "Offer bonuses and leave them alone",
          "Check in only when issues arise",
          "Offer regular feedback, acknowledge wins, and create growth opportunities",
          "Push them to take on more shifts"
        ],
        answer: "Offer regular feedback, acknowledge wins, and create growth opportunities"
      },    
      {
        question: "If a team member consistently arrives late, what is the best first step as a manager?",
        options: [
          "Ignore it unless someone complains",
          "Publicly call them out",
          "Pull them aside privately, review expectations, and document the conversation",
          "Reduce their hours immediately"
        ],
        answer: "Pull them aside privately, review expectations, and document the conversation"
      },
      {
        question: "How should you respond when a team member offers valid feedback about an outdated SOP?",
        options: [
          "Dismiss it and stick to protocol",
          "Ask them to write a new one themselves",
          "Listen, thank them, and bring it up during the next leadership review",
          "Ignore the comment"
        ],
        answer: "Listen, thank them, and bring it up during the next leadership review"
      },
      {
        question: "What’s the best way to keep morale high during a busy or understaffed day?",
        options: [
          "Buy coffee and stay out of the way",
          "Push everyone to move faster",
          "Check in with each team, recognize efforts, and support break flow",
          "Avoid engaging until the end of day"
        ],
        answer: "Check in with each team, recognize efforts, and support break flow"
      },
      {
        question: "How should a manager handle a conflict between two staff members that affects operations?",
        options: [
          "Let them work it out",
          "Tell them to stay professional and move on",
          "Hold a private mediation, listen to both sides, and follow up with expectations",
          "Ask HR to handle it immediately"
        ],
        answer: "Hold a private mediation, listen to both sides, and follow up with expectations"
      },
      {
        question: "If a pet injury occurs under staff care, what is the correct response as a manager?",
        options: [
          "Wait for the pet parent to bring it up",
          "Log it privately and keep it internal",
          "Ensure the pet gets medical attention, alert the parent, and submit a full internal report",
          "Avoid responsibility unless there’s a witness"
        ],
        answer: "Ensure the pet gets medical attention, alert the parent, and submit a full internal report"
      },
      {
        question: "What’s the most effective way to delegate tasks during a shift change?",
        options: [
          "Assign everything to one person",
          "Verbally list things and leave",
          "Review open tasks, assign clearly by name, and check for understanding",
          "Wait until the new shift asks for updates"
        ],
        answer: "Review open tasks, assign clearly by name, and check for understanding"
      },
      {
        question: "A staff member asks for a schedule change that affects coverage. How should a manager proceed?",
        options: [
          "Decline immediately",
          "Approve it without reviewing the schedule",
          "Check team coverage, explore solutions, and communicate clearly with all affected",
          "Tell them to find a replacement themselves"
        ],
        answer: "Check team coverage, explore solutions, and communicate clearly with all affected"
      },
      {
        question: "What’s the most important trait of a successful manager at Pawsible?",
        options: [
          "Being the fastest at every task",
          "Avoiding mistakes",
          "Balancing accountability with empathy, clarity, and follow-through",
          "Delegating everything to others"
        ],
        answer: "Balancing accountability with empathy, clarity, and follow-through"
      },
      {
        question: "How should a manager ensure team-wide understanding of a new policy?",
        options: [
          "Post it in the break room and hope they read it",
          "Mention it once during a rush",
          "Announce it verbally and follow up in writing with time for questions",
          "Only tell leads and assume they’ll share it"
        ],
        answer: "Announce it verbally and follow up in writing with time for questions"
      },
      {
        question: "If a staff member delivers exceptional service that a client raves about, what should the manager do?",
        options: [
          "Tell them not to let it go to their head",
          "Say thanks privately",
          "Publicly acknowledge the win and reinforce their positive impact",
          "Say nothing unless it happens again"
        ],
        answer: "Publicly acknowledge the win and reinforce their positive impact"
      },
      {
        question: "How can a manager role-model Pawsible’s values to the team daily?",
        options: [
          "By being the first to clock in and last to leave",
          "By holding others accountable but skipping check-ins",
          "By demonstrating respectful communication, professionalism, and care in every interaction",
          "By handling everything independently"
        ],
        answer: "By demonstrating respectful communication, professionalism, and care in every interaction"
      },
      {
        question: "How should a manager respond if they made a mistake that affected the team?",
        options: [
          "Ignore it and move on",
          "Blame miscommunication",
          "Own the mistake, share the fix, and thank the team for their patience",
          "Avoid talking about it"
        ],
        answer: "Own the mistake, share the fix, and thank the team for their patience"
      },
      {
        question: "If a team member frequently skips steps in an SOP (e.g. skipping post-groom photo or failing to log incidents), what should the manager do?",
        options: [
          "Let it slide if clients don’t complain",
          "Publicly call them out to set an example",
          "Review the SOP with them, reinforce why each step matters, and track follow-through",
          "Tell another staff member to remind them next time"
        ],
        answer: "Review the SOP with them, reinforce why each step matters, and track follow-through"
      },
      {
        question: "If a client is visibly upset and threatens to leave a bad review, what’s the manager’s best next step?",
        options: [
          "Offer a discount immediately",
          "Politely ask them to leave",
          "Stay calm, listen without defensiveness, offer resolution, and document the interaction",
          "Let front desk continue handling it"
        ],
        answer: "Stay calm, listen without defensiveness, offer resolution, and document the interaction"
      },
      {
        question: "What should a manager do during slower periods of the day?",
        options: [
          "Use the time to catch up on their own tasks only",
          "Let staff relax without direction",
          "Check in with departments, tidy shared areas, and support catch-up tasks or team coaching",
          "Leave early if everything looks calm"
        ],
        answer: "Check in with departments, tidy shared areas, and support catch-up tasks or team coaching"
      }      
    ],
};